import { actions, getVoiceActorsDatatableAsync } from './slices';

export const VoiceActorsActions = {
  ...actions,
  getVoiceActorsDatatableAsync,
};

export * from './thunkHandlers';
